module.exports = __webpack_public_path__ + "img/parent-profile.e49932b1.svg";